import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCard } from '../patterns';
import {
  OverdueOrchard,
  RecentDetection,
  InactiveScouter,
} from '../../utils/scoutingDashboardMath';

interface Props {
  overdue: OverdueOrchard[];
  detections: RecentDetection[];
  inactive: InactiveScouter[];
  pestMap: Record<string, string>;
}

export const ScoutingAlertStack: React.FC<Props> = ({ overdue, detections, inactive, pestMap }) => {
  const { t } = useTranslation();
  if (overdue.length === 0 && detections.length === 0 && inactive.length === 0) return null;
  return (
    <div className="scouting-alert-stack">
      {overdue.length > 0 && (
        <AlertCard
          title={t('dashboard.scouting.alerts.overdue')}
          count={overdue.length}
          tone="danger"
          viewAllHref="/scouting/review"
        >
          <ul className="scouting-alert-stack__list">
            {overdue.map(o => (
              <li key={o.orchardId}>
                <span className="scouting-alert-stack__primary">{o.orchardName}</span>
                <span className="scouting-alert-stack__meta">{t('dashboard.days', { count: o.daysSince })}</span>
              </li>
            ))}
          </ul>
        </AlertCard>
      )}
      {detections.length > 0 && (
        <AlertCard
          title={t('dashboard.scouting.alerts.pestDetections')}
          count={detections.length}
          tone="warn"
        >
          <ul className="scouting-alert-stack__list">
            {detections.map((d, i) => (
              <li key={`${d.orchardId}-${i}`}>
                <span className="scouting-alert-stack__primary">{pestMap[d.pestId] ?? d.pestId}</span>
                <span className="scouting-alert-stack__meta">{d.orchardName}</span>
              </li>
            ))}
          </ul>
        </AlertCard>
      )}
      {inactive.length > 0 && (
        <AlertCard
          title={t('dashboard.scouting.alerts.inactiveScouters')}
          count={inactive.length}
          tone="warn"
        >
          <ul className="scouting-alert-stack__list">
            {inactive.map(s => (
              <li key={s.scouterName}>
                <span className="scouting-alert-stack__primary">{s.scouterName}</span>
                <span className="scouting-alert-stack__meta">{t('dashboard.days', { count: s.lastActiveDays })}</span>
              </li>
            ))}
          </ul>
        </AlertCard>
      )}
    </div>
  );
};
